import { Component, PropsWithChildren } from 'react';
import { DataGridPanel } from './DataGridPanel';
import { ISingleProps } from './types';

export class SingleSelectPanel<T> extends Component<ISingleProps<T>, {}> {
  public render() {
    return DataGridPanel.single<T>(this.props);
  }
}

export default SingleSelectPanel;
